module.exports = __webpack_public_path__ + "static/media/logo-white.91179ee2.svg";